export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./full-version.vue?vue&type=template&id=28f236a9&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/modals/full-version.vue?vue&type=template&id=28f236a9&
// module id = 1351
// module chunks = 0